import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UtilitiesModule } from '../utilities/utilities.module';
import { SmsViewComponent } from './sms-view/sms-view.component';
import { SmsListComponent } from './sms-list/sms-list.component';
import { SmsService } from './sms.service';
import { ComponentsModule } from '../components/components.module';
import { ListSmsMessageComponent } from './sms-list/list-sms-message/list-sms-message.component';
import { ChooseUsersListItemFullContactValueComponent } from './choose-users-list-item-full-contact-value/choose-users-list-item-full-contact-value.component';
import { FiSmsEditComponent } from './sms-edit/sms-edit.component';
import { FormsModule } from '@angular/forms';
import { OperationOverlayLargeModule } from '../utilities/operation-overlay-large/operation-overlay-large.module';
import { UserModule } from '../user/user.module';
import { SmsStates } from '@fi-app/sms/sms-states';
import { UIRouterModule } from '@uirouter/angular';
import { FiSmsStateRootComponent } from '@fi-app/sms/sms-state-root/sms-state-root.component';
import { FiSmsCostsModule } from '@fi-app/sms/sms-costs/sms-costs.module';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FiPageHeaderModule } from '@fi-app/components/fi-page-header/fi-page-header.module';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { SelectSearchModule } from '@fi-shared/fi-select-search/select-search.module';
import { FiWrapperTableModule } from '@fi-shared/fi-wrapper-table/fi-wrapper-table.module';
import { FiLocalSearch2Module } from '@fi-shared/fi-local-search2/fi-local-search2.module';
import { FiSmsUsersDialogComponent } from './fi-sms-users-dialog/fi-sms-users-dialog.component';
import { FiContactsModule } from '@fi-shared/fi-contacts/fi-contacts.module';

@NgModule({
    imports: [
        CommonModule,
        UtilitiesModule,
        ComponentsModule,
        FormsModule,
        OperationOverlayLargeModule,
        UserModule,
        UIRouterModule.forChild(SmsStates),
        FiSmsCostsModule,
        MatIconModule,
        MatButtonModule,
        FiPageHeaderModule,
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        SelectSearchModule,
        FiWrapperTableModule,
        FiLocalSearch2Module,
        FiContactsModule,
    ],
    declarations: [
        SmsViewComponent,
        SmsListComponent,
        ListSmsMessageComponent,
        ChooseUsersListItemFullContactValueComponent,
        FiSmsEditComponent,
        FiSmsStateRootComponent,
        FiSmsUsersDialogComponent,
    ],
    providers: [SmsService],
})
export class SmsModule {}
